/** 푸시 알림 카테고리: 공지사항 vs 결재 */

export const NOTIF_CATEGORIES = {
  notice: 'notice',
  approval: 'approval',
};

const APPROVAL_KINDS = new Set(['leave', 'purchase_order', 'quote', 'order']);
const APPROVAL_TITLE_RE = /결재|결제|연차|휴가|구매발주|견적|주문서|승인|반려/;

/** FCM 수신 저장 시 push_type 결정 */
export function resolvePushTypeForSave(detail = {}) {
  const kind = String(detail.kind || detail.push_type || '').trim().toLowerCase();
  const title = String(detail.title || '');
  if (kind === 'approval') return 'approval';
  if (APPROVAL_KINDS.has(kind)) return 'approval';
  if (APPROVAL_TITLE_RE.test(title)) return 'approval';
  return 'broadcast';
}

/** 목록 표시용 카테고리 */
export function getNotifCategory(notif = {}) {
  const pushType = String(notif.pushType || '').trim().toLowerCase();
  const kind = String(notif.pushData?.kind || '').trim().toLowerCase();
  const title = String(notif.title || '');

  if (pushType === 'approval') return NOTIF_CATEGORIES.approval;
  if (APPROVAL_KINDS.has(kind)) return NOTIF_CATEGORIES.approval;
  if (APPROVAL_TITLE_RE.test(title)) return NOTIF_CATEGORIES.approval;

  if (pushType === 'individual' && !notif.isBroadcastOnly) {
    if (kind === 'outgoing') return NOTIF_CATEGORIES.notice;
    if (APPROVAL_TITLE_RE.test(title)) return NOTIF_CATEGORIES.approval;
  }

  return NOTIF_CATEGORIES.notice;
}

export function categoryLabel(category) {
  return category === NOTIF_CATEGORIES.approval ? '결재' : '공지사항';
}

export function filterNotifsByCategory(notifs, category) {
  if (!category || category === 'all') return notifs;
  return notifs.filter((n) => getNotifCategory(n) === category);
}

export function countUnreadByCategory(notifs, category) {
  const list = filterNotifsByCategory(notifs, category);
  return list.filter((n) => !n.read).length;
}

/** 공지사항 본문: 클릭 없이 최대 3줄 미리보기 */
export const NOTICE_BODY_PREVIEW_STYLE = {
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-word',
  lineHeight: 1.65,
  whiteSpace: 'normal',
  minHeight: 'calc(1.65em * 3)',
};
